import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/crystaSureLogo.svg'
import _imports_1 from '@/assets/completedIcon.svg'
import _imports_2 from '@/assets/inprogressIcon.svg'
import _imports_3 from '@/assets/notStartedIcon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2c82b6bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar bg-white sticky z-50 top-0 left-0 flex shadow p-2" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"navbar-start\" data-v-2c82b6bc><div class=\"w-40\" data-v-2c82b6bc><div class=\"lg:flex\" data-v-2c82b6bc><span class=\"text-lg font-bold cursor-pointer\" data-v-2c82b6bc><img src=\"" + _imports_0 + "\" alt=\"\" class=\"crystallineLogo h-8\" data-v-2c82b6bc></span></div></div></div>", 1)
const _hoisted_3 = { class: "navbar-center" }
const _hoisted_4 = { class: "items-center justify-center lg:flex" }
const _hoisted_5 = { class: "navbar-end" }
const _hoisted_6 = {
  class: "p-4",
  style: {"overflow-y":"scroll"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Course Modules")
], -1))
const _hoisted_8 = {
  ref: "moduleContainer",
  class: "flex gap-2 flex-wrap mt-2"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "h-4/6" }
const _hoisted_11 = {
  key: 0,
  class: "h-32 flex justify-center relative"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "bg-primary flex justify-center items-center t"
}
const _hoisted_14 = { class: "text-white text-lg" }
const _hoisted_15 = { class: "card-body p-4 h-2/6" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "w-3/4" }
const _hoisted_18 = { class: "mb-0 h-12" }
const _hoisted_19 = { class: "w-1/4 flex flex-row-reverse mb-3.5" }
const _hoisted_20 = {
  key: 0,
  src: _imports_1,
  class: "w-8 moduleCompleted"
}
const _hoisted_21 = {
  key: 1,
  src: _imports_2,
  class: "w-8 moduleActive"
}
const _hoisted_22 = {
  key: 2,
  src: _imports_3,
  class: "w-8 moduleInactive"
}
const _hoisted_23 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.courseDetails.coursename), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btnprimary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExit()))
        }, "EXIT")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modulesdata, (module) => {
          return (_openBlock(), _createElementBlock("div", {
            key: module.id,
            class: "mt-2",
            onClick: ($event: any) => (_ctx.onedit(module))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["card h-72 w-80 cursor-pointer rounded", { 'pointer-events-none': !(module.isActive || module.isCompleted) }])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("figure", null, [
                  (module.imageUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("img", {
                          src: module.imageUrl,
                          class: "card-bordered w-full bg-cover bg-no-repeat bg-center"
                        }, null, 8, _hoisted_12)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("h1", _hoisted_14, _toDisplayString(module.moduleName), 1)
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(module.moduleName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    (module.isCompleted)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                      : _createCommentVNode("", true),
                    (module.isActive)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                      : _createCommentVNode("", true),
                    (!(module.isActive || module.isCompleted))
                      ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("progress", {
                  class: "progress progress-primary mt-2",
                  value: module.isActive || module.isCompleted ? (module.completedScreens / module.totalScreens) * 100 : 0,
                  max: "100"
                }, null, 8, _hoisted_23)
              ])
            ], 2)
          ], 8, _hoisted_9))
        }), 128))
      ], 512)
    ])
  ]))
}